import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useUpdateChallenge = () => {
  return useMutation((newTest) => {
    return axiosPost("/api/cw/updateChallenge", newTest);
  });
};

export default useUpdateChallenge;
